import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AttachmentsGrid } from './AttachmentsGrid';
import { BulkAddMembersToGroup } from './BulkAddMembersToGroup';
import { GroupAdminsGrid } from './GroupAdminsGrid';
import { GroupBookingBulkUpload } from './GroupBookingBulkUpload';
import { InstitutionGroupCreate } from './InstitutionGroupCreate';
import { InstitutionGroupDelete } from './InstitutionGroupDelete';
import { InstitutionGroupDisplay } from './InstitutionGroupDisplay';
import { InstitutionGroupEventBulkCopy } from './InstitutionGroupEventBulkCopy';
import { InstitutionGroupSearch } from './InstitutionGroupSearch';
import { InstitutionGroupTimeLabelGrid } from './InstitutionGroupTimeLabelGrid';
import { InstitutionGroupTimeLabelList } from './InstitutionGroupTimeLabelList';
import { InstitutionGroupUpdate } from './InstitutionGroupUpdate';
import { Four04 } from 'gossamer-front-end';

export const InstitutionGroupRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/admins-grid/:key" element={<GroupAdminsGrid />} />
    <Route path="/attachments-grid/:key" element={<AttachmentsGrid />} />
    <Route path="/bulk-upload-members/:key" element={<BulkAddMembersToGroup />} />
    <Route path="/create" element={<InstitutionGroupCreate />} />
    <Route path="/delete/:key" element={<InstitutionGroupDelete />} />
    <Route path="/display/:key" element={<InstitutionGroupDisplay />} />
    <Route path="/event-bulk-copy/:key" element={<InstitutionGroupEventBulkCopy />} />
    <Route path="/group-booking-bulk-upload" element={<GroupBookingBulkUpload />} />
    <Route path="/search" element={<InstitutionGroupSearch />} />
    <Route path="/time-labels-grid/:key" element={<InstitutionGroupTimeLabelGrid />} />
    <Route path="/time-labels-list/:key" element={<InstitutionGroupTimeLabelList />} />
    <Route path="/update/:key" element={<InstitutionGroupUpdate />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
